import _ from 'underscore';

export const getAIGCODataService = ({
  odata, oDataConfig, aid, cid,
}) => {
  const generateImagesWithAIAsync = (userPrompt, skipBrandDetection = true) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateImagesWithAI`;
    const requestBody = {
      UserPrompt: userPrompt,
      SkipBrandDetection: skipBrandDetection,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const getAIGeneratedImageTaskStatus = (taskId) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.AIGenerateImagesTaskStatus(TaskId='${taskId}')`;
    return odata.get(url, oDataConfig);
  };

  return {
    generateImagesWithAIAsync,
    getAIGeneratedImageTaskStatus,
  };
};

